import { faExpand, faPlus, faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  ActionIcon,
  AspectRatio,
  Button,
  Grid,
  Group,
  Image,
  Paper,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { RunningAdvertisementDto } from '../../models/RunningAdvertisementDto'
import { COLORS } from '../../utils/constants'
import classes from './AdGrid.module.css'

interface AdGridProps {
  runningAds: RunningAdvertisementDto[]
  onUploadClick: () => void
  onExpandAd: (ad: RunningAdvertisementDto) => void
  onDisableAd: (ad: RunningAdvertisementDto) => void
}

export function AdGrid({
  runningAds,
  onUploadClick,
  onExpandAd,
  onDisableAd,
}: AdGridProps) {
  return (
    <Stack gap='md'>
      <Group justify='space-between' align='center'>
        <Title order={2}>Running Advertisements</Title>
        <Text size='sm' c='dimmed'>
          {runningAds.length} active advertisements
        </Text>
      </Group>
      {runningAds.length === 0 ? (
        <Paper shadow='sm' radius='md' p='xl' withBorder>
          <Stack align='center' gap='md'>
            <Text size='lg' c='dimmed'>
              No Running Advertisements
            </Text>
            <Text size='sm' c='dimmed'>
              This device currently has no active advertisements.
            </Text>
            <Button
              leftSection={<FontAwesomeIcon icon={faUpload} />}
              onClick={onUploadClick}
              mt='md'
            >
              Upload Your Own Ad
            </Button>
          </Stack>
        </Paper>
      ) : (
        <Grid>
          <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
            <Paper
              shadow='sm'
              radius='md'
              withBorder
              className={classes.uploadCard}
              onClick={onUploadClick}
              py='xl'
            >
              <Stack
                align='center'
                justify='center'
                gap='md'
                className={classes.uploadContent}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  size='2x'
                  color='#868e96'
                  className={classes.uploadIcon}
                />
                <Text size='sm' c='dimmed' className={classes.uploadText}>
                  Upload Your Own Ad
                </Text>
              </Stack>
            </Paper>
          </Grid.Col>
          {runningAds.map((ad) => (
            <Grid.Col key={ad.id} span={{ base: 12, sm: 6, md: 3 }}>
              <Paper shadow='sm' radius='md' withBorder>
                <div style={{ position: 'relative' }}>
                  <AspectRatio ratio={16 / 9}>
                    <Image
                      src={ad.imageUrl}
                      alt={`Advertisement ${ad.id}`}
                      radius='md'
                    />
                  </AspectRatio>
                  <ActionIcon
                    variant='filled'
                    radius='md'
                    onClick={() => onExpandAd(ad)}
                    style={{
                      position: 'absolute',
                      bottom: 8,
                      right: 8,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      width: 32,
                      height: 32,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    visibleFrom='sm'
                  >
                    <FontAwesomeIcon
                      icon={faExpand}
                      style={{ fontSize: '14px', color: 'white' }}
                    />
                  </ActionIcon>
                </div>
                <Stack p='md' gap='xs'>
                  <Group justify='space-between' align='center'>
                    <Text size='xs' c='dimmed'>
                      {ad.startDate && ad.endDate
                        ? `${new Date(
                            ad.startDate,
                          )?.toLocaleDateString()} - ${new Date(
                            ad.endDate,
                          )?.toLocaleDateString()}`
                        : 'No dates specified'}
                    </Text>
                    <Text
                      component='button'
                      onClick={() => onDisableAd(ad)}
                      c={COLORS.HiddenGemzRed}
                      style={{
                        textDecoration: 'underline',
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        fontSize: '12px',
                      }}
                    >
                      Disable Ad
                    </Text>
                  </Group>
                </Stack>
              </Paper>
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Stack>
  )
}
